import { createRouter, createWebHistory } from 'vue-router'
import {submission} from "../utilities/submission"
import HomeView from '../views/HomeView.vue'
import store from '../store'
import app from '../main'

import AuthLayout from '../views/layouts/Auth.vue'
import App from '../views/layouts/App.vue'
import Public from '../views/layouts/Public.vue'


import Login from '../views/auth/Login.vue'
import SendResetLink from '../views/auth/SendResetLink.vue'
import ResetPassword from '../views/auth/ResetPassword.vue'

import Dashboard from '../views/Dashboard.vue'
import Disclaimer from '../views/Disclaimer.vue'
import NotFound from '../views/NotFound.vue'


import FileMigrator from '../views/FileMigrator.vue'





import Evaluations from '../views/evaluations/Evaluations.vue'
import SupplierBrands from '../views/evaluations/SupplierBrands.vue'
import SupplierProjectDetail from '../views/evaluations/SupplierProjectDetail.vue'
import SupplierBrandDetail from '../views/evaluations/SupplierBrandDetail.vue'
import BrandDetailInfo from '../views/evaluations/BrandDetailInfo.vue'
import SupplierBrandDetailBrandInfo from '../views/evaluations/SupplierBrandDetailBrandInfo.vue'
import SupplierBrandDetailProjects from '../views/evaluations/SupplierBrandDetailProjects.vue'
import SupplierBrandDetailProjectsIndex from '../views/evaluations/SupplierBrandDetailProjectsIndex.vue'
import BrandDetailProject from '../views/evaluations/BrandDetailProject.vue'
import BrandDetailFlows from '../views/evaluations/BrandDetailFlows.vue'
import BrandDetailFlow from '../views/evaluations/BrandDetailFlow.vue'
import Evaluation from '../views/evaluations/Evaluation.vue'
import EvaluationEducation from '../views/evaluations/EvaluationEducation.vue'
import EvaluationEducationVideo from '../views/evaluations/EvaluationEducationVideo.vue'
import EvaluationProgress from '../views/evaluations/EvaluationProgress.vue'
import EvaluationInfo from '../views/evaluations/EvaluationInfo.vue'
import EvaluationSection from '../views/evaluations/EvaluationSection.vue'



import SupplierProjectFlowSummary from '../views/suppliers/SupplierProjectFlowSummary.vue'




import {verifications,verification} from "./modules/verification_routes"
import {preaudits,preaudit} from "./modules/preaudit_routes"
import {flows,flow} from "./modules/flow_routes"
import {question} from "./modules/question_routes"
import {suppliers,supplier,create_supplier,closurerequests,certificate_uploads,beyzaya_ozel,intermediate_flow_supplier,add_addresses} from "./modules/supplier_routes"
import {users,user,create_user,connected_users,notification,supplier_contacts} from "./modules/user_routes"
import {brands,brand,create_brand} from "./modules/brand_routes"
import {questionlists,questionlist,questionlistpreview,questionlist_previews} from "./modules/questionlist_routes"
import {educationpacks,educationpack} from "./modules/educationpack_routes"
import {section} from "./modules/section_routes"
import {languages,language,create_language} from "./modules/language_routes"
import {certificatetypes,certificatetype,create_certificatetype} from "./modules/certificatetype_routes"
import {projects,project,create_project} from "./modules/project_routes"
import {tickets,ticket,resolved_tickets} from "./modules/ticket_routes"
import {supplierbrands,supplierbrand} from "./modules/supplierbrand_routes"
import {auditor_verifications,auditor_verification} from "./modules/auditor_verification_routes"
import {auditor_audits,auditor_audit} from "./modules/auditor_audit_routes"
import {audit_schedules,audit_schedule} from "./modules/scheduled_audit_routes"
import {audits} from "./modules/audit_routes"

import {countries,country,create_country} from "./modules/country_routes"
import {generalpurposedatatypes} from "./modules/generalpurposedata_routes"









let isAccessGranted = async (accessroles)=>{
  let user = store.state.auth.user
  if(!user)
  {
    return false
  }
  let roles = await store.state.auth.user.userroles
  let accessgranted = await true
  if(accessroles && accessroles.length)
  {
    accessgranted = await false
    for(let role of roles)
    {
      if(accessroles.includes(role.name))
      {
        accessgranted = await true
      }
    }
  }

  return await accessgranted
}

let roleSystemRoute = async (to, from, next)=>
{
  
  let accessgranted = await isAccessGranted(to.meta.accessroles)
  if(accessgranted)
  {
    await next();
  }
  else
  {
    next({ name: 'NotFound' })
  }

} 




let guardSystemRoute = async (to, from, next)=>
{
  //await store.dispatch('auth/setRedirectPath',to)
  
   let token = await store.state.auth.token
   //token not in state
   if(!token)
   {
      token = await localStorage.getItem("vrf_token");
      //token not in localStorage
      if(!token)
      {
       await  next('/login');
      }
      //token not in localStorage
      //token in localStorage
      else
      {
       await store.dispatch('auth/setToken',token)
       let user = await store.state.auth.user
       //user not set
       if(!user)
       {
          user = await submission.methods.getUserData()
          //route uuid not matches state uuid
          if(to.params.uuid!==user.user.uuid)
          {
            let params = await to.params
            params.uuid = await user.user.uuid
            let accessgranted = await isAccessGranted(to.meta.accessroles)
            if(accessgranted)
            {
              await next({name:to.name,params:params})
            }
            else
            {
              next({ name: 'NotFound' })
            }
            
          }
          //route uuid not matches state uuid
          //route uuid matches state uuid
          else
          {

            let accessgranted = await isAccessGranted(to.meta.accessroles)
            if(accessgranted)
            {
              await next()
            }
            else
            {
              next({ name: 'NotFound' })
            }
          }
          //route uuid matches state uuid
          
       }
       //user not set
       //user set
       else
       {
        if(to.params.uuid!==user.user.uuid)
        {
          
            let params = await to.params
            params.uuid = await user.user.uuid
            let accessgranted = await isAccessGranted(to.meta.accessroles)
            if(accessgranted)
            {
              await next({name:to.name,params:params})
            }
            else
            {
              next({ name: 'NotFound' })
            }
        }
        else
        {

          let accessgranted = await isAccessGranted(to.meta.accessroles)
            if(accessgranted)
            {
              await next()
            }
            else
            {
              next({ name: 'NotFound' })
            }
        }
       }
       //user set
      }
      //token in localStorage
   }
   //token not in state
   //token not state
   else
   {
    let user = await store.state.auth.user
    //user not in state
    if(!user)
    {
        user = await submission.methods.getUserData()   
        if(to.params.uuid!==user.user.uuid)
        {
          let params = await to.params
          params.uuid = await user.user.uuid
          await next({name:to.name,params:params})
        }
        else
        {

          await next()
        }   
    }
    //user not in state
    //user in state
    else{

     await next();
    }
    //user in state
   }


  
}
let checkAuthRoutes = (to)=>
{
  if(to.name=="Login"||to.name=="SendResetLink" || to.name=="ResetPassword")
  {
    return true
  }
  else
  {
    return false
  }
}

let  guardAuthRoute = async (to, from, next)=>
{
  
  let token = await localStorage.getItem("vrf_token");

  if(token)
  {

    await store.dispatch('auth/setToken',token)
    let user = await store.state.auth.user
    
    if(!user)
    {   
      user = await submission.methods.getUserData()
      if(user)  
      {
        if(checkAuthRoutes(to))
        {

          await next('/'+user.user.uuid);
        }
        else
        {
          
          await next('/'+user.user.uuid+to.path);
        }
        
      }     
      else
      {
           if(checkAuthRoutes(to))
            {
              await  next(to.path) 
            }
            else
            {
              await  next("/login") 
            }    
      }
          
    }
    else
    {
       if(checkAuthRoutes(to))
        {
          await  next(to.path) 
        }
        else
        {
          await  next("/login") 
        }
    }

  }
  else
  {
     next()
  }
 
}




const routes = [
  { path: '/:pathMatch(.*)*', 
  component: NotFound, 
  name: 'NotFound',
  meta: {
          title: "404",
          domain:"dashboard"
        },
  },
  {
    path: '/:uuid',
    name: 'App',
    component: App,
    redirect: { name: 'Dashboard' },
    beforeEnter : guardSystemRoute,
     children:[
      //dashboard
      {
      path: 'dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
          title: "dashboard",
          domain:"dashboard",
          accessroles:["admin","planner","auditor","brand","supplier"],
        },
      },
      //dashboard

      //filemigrator
      {
      path: 'filemigrator',
      name: 'FileMigrator',
      component: FileMigrator,
      meta: {
          title: "FileMigrator",
          domain:"filemigrator",
          accessroles:["admin","planner","auditor","brand","supplier"],
        },
      },
      //filemigrator
      //disclaimer
      {
      path: 'disclaimer',
      name: 'Disclaimer',
      component: Disclaimer,
      meta: {
          title: "Disclaimer",
          domain:"disclaimer",
          accessroles:["admin","planner","auditor","brand","supplier"],
        },
      },
      //disclaimer
      users,
      create_user,
      connected_users,
      supplier_contacts,
      notification,
      user,
      brands,
      create_brand,
      brand,
      projects,
      project,
      create_project,
      verifications,  
      verification,
      preaudits,
      preaudit,
      flows,  
      flow,     
      educationpacks,
      educationpack,
      questionlists,
      questionlistpreview,
      questionlist_previews,
      questionlist,
      section,
      question,
      suppliers,
      supplier,
      create_supplier,
      closurerequests,
      beyzaya_ozel,
      add_addresses,
      intermediate_flow_supplier,
      certificate_uploads,
      languages,
      language,
      create_language,
      tickets,
      resolved_tickets,
      ticket,
      supplierbrands,
      supplierbrand,
      auditor_verifications,
      auditor_verification,
      auditor_audits,
      auditor_audit,
      audit_schedules,
      audit_schedule,
      audits,

      //audits
      /*
      {
      path: 'audits',
      name: 'Audits',
      component: Audits,
      meta: {
          title: "Denetlemeler",
          domain:"audits"
        },
      },
      */
      //audits
      certificatetypes,
      create_certificatetype,
      certificatetype,
      countries,
      country,
      create_country,
      generalpurposedatatypes,
      //evaluations
      {
      path: 'evaluations',
      name: 'Evaluations',
      component: Evaluations,
      meta: {
          title: "verification",
          domain:"evaluations"
        },
      },
      /*
      {
      path: 'supplier_brands',
      name: 'SupplierBrands',
      component: SupplierBrands,
      meta: {
          title: "Tedarikçi Markaları",
          domain:"supplier_brands"
        },
      },
      */
      /*
      {
      path: 'project_detail/:project_id',
      name: 'SupplierProjectDetail',
      component: SupplierProjectDetail,
      meta: {
          title: "Proje",
          domain:"supplier_brands"
        },
      },
      */
      {
      path: 'project_detail/:project_id/flow_summary/:flow_id',
      name: 'SupplierProjectFlowSummaryForSupplier',
      component: SupplierProjectFlowSummary,
      meta: {
          title: "proje",
          domain:"supplier_brands"
        },
      },
      {
      path: 'brand_info/:brand_uuid',
      name: 'SupplierBrandDetail',
      component: SupplierBrandDetail,
      redirect: { name: 'SupplierBrandDetailBrandInfo' },
      meta: {
          title: "marka",
          domain:"supplier_brands"
        },
        children:[
           {
          path: 'info',
          name: 'BrandDetailInfo',
          component: BrandDetailInfo,
          meta: {
              title: "bilgi",
            },
          },
          {
          path: 'brand',
          name: 'SupplierBrandDetailBrandInfo',
          component: SupplierBrandDetailBrandInfo,
          meta: {
              title: "marka",
            },
          },
          {
          path: 'flows',
          name: 'BrandDetailFlows',
          component: BrandDetailFlows,
          meta: {
              title: "akislar",
            },
          },
          {
          path: 'flow/:flow_uuid',
          name: 'BrandDetailFlow',
          component: BrandDetailFlow,
          meta: {
              title: "akis",
            },
          },
        ]
      },
      {
      path: 'evaluation/:id',
      name: 'Evaluation',
      component: Evaluation,
      //redirect: { name: 'EvaluationInfo' },
      meta: {
          title: "degerlendirme",
          domain:"supplierbrands"
        },
        children:[
         {
          path: 'info',
          name: 'EvaluationInfo',
          component: EvaluationInfo,
          meta: {
              title: "bilgi",
            },
          },
          {
          path: 'progress',
          name: 'EvaluationProgress',
          component: EvaluationProgress,
          meta: {
              title: "denetleme",
            },            
          },
         {
          path: 'section/:section_id',
          name: 'EvaluationSection',
          component: EvaluationSection,
          meta: {
              title: "bolum",
            },
          },
          {
          path: 'education',
          name: 'EvaluationEducation',
          component:EvaluationEducation,
          meta: {
              title: "egitim",
            },
          },
          {
          path: 'course/:video_id',
          name: 'EvaluationEducationVideo',
          component:EvaluationEducationVideo,
          meta: {
              title: "video",
            },
          },
        ]
      },
      //evaluations

      

     ]
  },
  {
    path: '/',
    name: 'AuthLayout',
    component: AuthLayout,
    beforeEnter : guardAuthRoute,
    redirect: { name: 'Login' },
    children:[
      //login
      {
      path: 'login',
      name: 'Login',
      component: Login,
      meta: {
          title: "giris",
        },
      },
      //login
      //SendResetLink
      {
      path: 'reset-password',
      name: 'SendResetLink',
      component: SendResetLink,
      meta: {
          title: "sifirlama_linki_yolla",
        },
      },
      //SendResetLink
      //ResetPassword
      {
      path: 'reset-password/:token',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: {
          title: "sifre_sifirlama",
        },
      },
      //ResetPassword
    ]
  },
]




const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from,next) => {

    //let user = await store.state.auth.user
    /*
    console.log("beforeEach")
    console.log(to)
    console.log(store.state.auth.user)

    if(to.meta.accessroles)
    {
       let accessgranted = await isAccessGranted(to.meta.accessroles)
      if(accessgranted)
      {
        await next();
      }
      else
      {
        await next({ name: 'NotFound' })
      }
    }
    else
    {
       
    }
    */

    await next()
   
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609  
    /*
    console.log("before each")
    console.log(to)  
    console.log(store.state.auth.user)
    let accessgranted = true
    if(store.state.auth.user)
    {
      
      let roles = store.state.auth.user.userroles
      let accessroles = to.meta.accessroles
      if(accessroles && accessroles.length)
      {
        accessgranted = false
        for(let role of roles)
        {
          if(accessroles.includes(role.name))
          {
            accessgranted = true
          }
        }
      }
      
    }

    if(accessgranted)
    {
      console.log("accessgranted")
      next()
    }
    else
    {
      console.log("accessgranted not")
      next({ name: 'NotFound' })
    }
    */
    //console.log("before each")
    //console.log(to.meta) 
   
    
    
    
    


});


router.afterEach((to, from) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609    
    let title = "VerifyHub"
    document.title = title

    if(to.meta.title)
    {
      
      let translation = store.state.languages.lang_phrases[to.meta.title]
      if(translation)
      {
       
        document.title = translation+" - "+title || title;
      }
    }
    
    //document.title = to.meta.title+" - "+title || title;
    if(to.meta.domain)
    {
      store.dispatch('ui/setActiveMenuItem',to.meta.domain)
    }
    store.dispatch('ui/setOffcanvasMenu',false)
    //app.config.globalProperties.$socket.emit('user_navigate', { to: to.fullPath,client:store.state.auth.user.uuid })
});

export default router
